import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = 'user'

const userInfo = JSON.parse(localStorage.getItem('userInfo'))

if (userInfo && userInfo.role_id !== undefined && userInfo.role_id !== null) {
  switch (Number(userInfo.role_id)) {
  case 0:
    initialRole = 'superadmin'
    break
  case 1:
    initialRole = 'admin'
    break
  case 2:
    initialRole = 'user'
    break
  }
}

export default new AclCreate({
  initial  : initialRole,
  notfound : '/pages/not-authorized',
  router,
  acceptLocalRules : true,
  globalRules: {
    superadmin: new AclRule('superadmin').generate(),
    admin  : new AclRule('admin').or('superadmin').generate(),
    financialAdmin: new AclRule('admin').or('superadmin').generate(),
    user  : new AclRule('user').generate(),
    editor : new AclRule('editor').or('admin').or('user').or('superadmin').generate()
  }
})
